import React from 'react';
import { AccountDetailsProps } from './types';
import { styles } from './styles';
import { CollapsiblePanel, DetailField } from '@v2/components';

const AccountDetails: React.FC<AccountDetailsProps> = ({ account }) => {
  return (
    <CollapsiblePanel title="Account Information" defaultExpanded>
      <div className={styles.fieldContainer}>
        <DetailField label="Name">
          {account.firstName} {account.lastName}
        </DetailField>
        <DetailField label="Email">{account.email}</DetailField>
        <DetailField label="Role">{account.role}</DetailField>
        {account.partners.length > 0 && (
          <DetailField label="Partners">
            {account.partners.map(partner => partner.name).join(', ')}
          </DetailField>
        )}
      </div>
    </CollapsiblePanel>
  );
};

export default AccountDetails;
